"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PushtextHref = exports.Pushtext = void 0;
var pushtext_1 = require("./pushtext");
Object.defineProperty(exports, "Pushtext", { enumerable: true, get: function () { return __importDefault(pushtext_1).default; } });
var pushtext_href_1 = require("./pushtext.href");
Object.defineProperty(exports, "PushtextHref", { enumerable: true, get: function () { return __importDefault(pushtext_href_1).default; } });
//# sourceMappingURL=index.js.map